import { getCookie } from '../shared/cookieHelper';

window.showImagePopupSearchResultPage = function (ele, transformation) {
    $("#myModalSearchRateResult").modal('show');

    var modalImg = document.getElementById("img01");

    modalImg.src = ele.src.replace("/upload", "/upload/" + transformation +"/");
}

$(function () {
    if ($('#search_rate_result_page').length) {

        $(function () {
            var slider = document.getElementById('slider'),
                sliderItems = document.getElementById('slides'),
                prev = document.getElementById('prev'),
                next = document.getElementById('next');

            function slide(wrapper, items, prev, next) {
                var posX1 = 0,
                    posX2 = 0,
                    posInitial,
                    posFinal,
                    threshold = 100,
                    slides = items.getElementsByClassName('slide'),
                    slidesLength = slides.length,
                    slideSize = items.getElementsByClassName('slide')[0].offsetWidth,
                    index = 0,
                    allowShift = true;

                wrapper.classList.add('loaded');

                function appendAfter(n, original, appendTo) {
                    for (var i = 0; i < n; i++) {
                        var clone = original[i].cloneNode(true);
                        appendTo.appendChild(clone);
                    }
                }

                prev.addEventListener('click', function () { shiftSlide(-1) });
                next.addEventListener('click', function () { shiftSlide(1) });

                items.addEventListener('transitionend', checkIndex);

                function dragStart(e) {
                    e = e || window.event;
                    e.preventDefault();
                    posInitial = items.offsetLeft;

                    if (e.type == 'touchstart') {
                        posX1 = e.touches[0].clientX;
                    } else {
                        posX1 = e.clientX;
                        document.onmouseup = dragEnd;
                        document.onmousemove = dragAction;
                    }
                }

                function dragAction(e) {
                    e = e || window.event;

                    if (e.type == 'touchmove') {
                        posX2 = posX1 - e.touches[0].clientX;
                        posX1 = e.touches[0].clientX;
                    } else {
                        posX2 = posX1 - e.clientX;
                        posX1 = e.clientX;
                    }
                    items.style.left = (items.offsetLeft - posX2) + "px";
                }

                function dragEnd(e) {
                    posFinal = items.offsetLeft;
                    if (posFinal - posInitial < -threshold) {
                        shiftSlide(1, 'drag');
                    } else if (posFinal - posInitial > threshold) {
                        shiftSlide(-1, 'drag');
                    } else {
                        items.style.left = (posInitial) + "px";
                    }

                    document.onmouseup = null;
                    document.onmousemove = null;
                }

                function shiftSlide(dir, action) {
                    items.classList.add('shifting');

                    if (allowShift) {
                        if (!action) { posInitial = items.offsetLeft; }

                        if (dir == 1) {
                            items.style.left = (posInitial - slideSize) + "px";
                            index++;
                        } else if (dir == -1) {
                            items.style.left = (posInitial + slideSize) + "px";
                            index--;
                        }
                    };

                    allowShift = false;
                }

                function checkIndex() {
                    items.classList.remove('shifting');

                    if (index == -1) {
                        items.style.left = -(slidesLength * slideSize) + "px";
                        index = slidesLength - 1;
                    }

                    if (index == slidesLength) {
                        items.style.left = -(1 * slideSize) + "px";
                        index = 0;
                    }
                    allowShift = true;
                }
            }

            slide(slider, sliderItems, prev, next);

            var $loading = $('#ll_loading-div').hide();
            var loc1 = getCookie("ll_prefix_url");

            $("#myModalSearchRateResult").modal('hide');

            $.ajax({
                url: loc1 + '/generate-flyer-background',
                type: 'POST',
                cache: false,
                contentType: false,
                processData: false,
                data: "",
                beforeSend: function () {
                },
                success: function (response) {
                    if (response != "") {
                    }
                }
            });

            $(document).on("click", ".popover .close", function () {
                $(this).parents(".popover").popover('hide');
            });

            var genericCloseBtnHtml = '<button onclick="$(this).closest(\'div.popover\').popover(\'hide\');" type="button" class="close" aria-hidden="true">&times;</button>';

            $('[data-toggle = "popover"]').popover({
                html: true,
                title: 'Repayment' + genericCloseBtnHtml,
                content: function () {
                    return $(this).next('.popper-content').html();
                }
            });

            $('[data-toggle="popover"]').on('click', function (e) {
                $('[data-toggle="popover"]').not(this).popover('hide');
            });

            $('[data-toggle="tooltip"]').tooltip();

            //$('#lnl_purchase').on('click', function () {
            //    $('#jumboWarningModal').modal('show slide');
            //});
        });
    }       
});
